webpackJsonp([198753679305028],{

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 4: Clean acquired data'
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '80', max: '100' },
	          '80 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* We\'ve missed an important step in AI training: data cleaning, i.e., fixing or removing incorrect, corrupted, incorrectly formatted, duplicate, or incomplete data within a dataset. By cleaning the training data, we\'re likely to reduce biases contained.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Please modify the sentences or add new sentences in the dataset locally, and then upload the new dataset. Your main goal is to make the dataset more fair in terms of gender.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://drive.google.com/file/d/1iWIcNAM3PbmYxn-Am9sNIjQsO3oUzqHe/view?usp=sharing', title: 'Dataset', target: '_blank' },
	            'Dataset'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Now let\'s run the code again and see what changes! Again, please run Google Colab below to see the newly predicted next word given the prompt of either "man" or "woman." After you go to Google Colab, select "Runtime->Run all". Under the section "Training with Bias", type either "man" or "woman" as the prompt and observe the next word. Repeat the process 10 times, 5 times with the prompt "man", and 5 times with "woman". Are there any changes compared to last time?'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://colab.research.google.com/drive/1hkzl1RfUJYYPaiDlos9ER6rYX4QJ9sTY?usp=sharing', title: 'Colab', target: '_blank' },
	            'Colab'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We\'re not done yet!'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/3-rf/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/5-unawareness/' },
	          'Next step'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-4-clean-js-340a446ef0dbc7bc0154.js